import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { GameComponent } from './game/game.component'
import { SimulatorComponent } from './simulator/simulator.component'

const routes: Routes = [
  { path: 'game', component: GameComponent },
  { path: 'simulator', component: SimulatorComponent },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
